/** Rotas canônicas dos dashboards por departamento (inglês, alinhado ao restante do app). */
export const DASHBOARD_AREA_ROUTES: Record<string, string> = {
  'dashboard.commercial': '/commercial',
  'dashboard.operations': '/operations',
  'dashboard.marketing': '/marketing',
  'dashboard.people': '/people',
  'dashboard.customer-success': '/customer-success',
  'dashboard.relationship': '/relationship',
};

const DASHBOARD_AREA_PATHS = new Set(Object.values(DASHBOARD_AREA_ROUTES));

export function resolveDashboardAreaRoute(moduleCode: string, fallbackRoutePath: string): string {
  return DASHBOARD_AREA_ROUTES[moduleCode] ?? fallbackRoutePath;
}

export function isDashboardAreaModule(moduleCode: string): boolean {
  return moduleCode in DASHBOARD_AREA_ROUTES;
}

/** True quando o path do menu é exatamente a visão geral do departamento (ex.: `/people`). */
export function isDashboardAreaPath(path: string): boolean {
  const normalized = (path || '/').split('?')[0] || '/';
  const withoutTrailing =
    normalized !== '/' && normalized.endsWith('/') ? normalized.slice(0, -1) : normalized;
  return DASHBOARD_AREA_PATHS.has(withoutTrailing);
}
